<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        v-on:closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-end py-2" v-if="!preview">
                    <v-btn @click="convertPlaceholders(measures.items)" color="primary">Riempimento automatico</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-simple-table class="measure_table">
                <template v-slot:default>
                    <thead class="expansion">
                    <tr>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                        <th class="table-text-blocks text-right">{{data.block.conf.headers.result}}</th>
                    </tr>
                    </thead>
                    <tr v-for="(item,index) of measures.items" :key="index">
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                            solo hide-details
                            :readonly="preview"
                            v-model="item.mass"
                            :precision="currentPrecision"
                            :negative="false"
                            :class="readingWarning(item.mass)"
                            @input="changeTare(item)" 
                            ></NumericField>
                        </td>
                        <td class="table-blocks text-left">
                            <NumericField dense outlined
                            solo hide-details
                            :readonly="preview"
                            v-model="item.reading"
                            :precision="currentPrecision"
                            :negative="false"
                            :class="readingWarning(item.reading)"
                            @input="changeTareReading(item)" 
                            :placeholder="'0'"
                            :enableicons="!preview"
                            :addfunc="readingAddFunc"
                            :subfunc="readingSubFunc"
                            :row="item"
                            :fieldname="'reading'"
                            :range="calcMinRange(item.reading)"
                            ></NumericField>
                            </td>
                        <td class="table-blocks text-left">
                             <NumericField dense outlined
                            solo hide-details
                            class="text-left"
                            :readonly="preview"
                            v-model="item.addLoad"
                            :precision="high_precision"
                            :negative="false"
                            @input="changeTareAddLoad(item)"
                            :placeholder="calculateAddLoadPlaceholder(item.reading)"
                            :class="addLoadWarning(item.addLoad, item.reading)"
                            :enableicons="!preview"
                            :addfunc="loadAddFunc"
                            :subfunc="loadSubFunc"
                            :row="item"
                            :fieldname="'addLoad'"
                            :range="calcMinRange(item.reading)"
                            ></NumericField>
                        </td>
                        <td class="text-right table-text-blocks"><b>{{item.p | formatNumber}}</b></td>
                        <td class="text-right table-text-blocks"><b>{{item.error | formatNumber}}</b></td>
                        <td class="text-right table-text-blocks"><b>{{item.mpe | formatNumber}}</b></td>
                        <td class="text-right table-text-blocks">
                            <StatusIcon :status="item.result" :tooltip_text="row_tooltip[item.result]" />
                        </td>
                    </tr>
                </template>           
            </v-simple-table>
            </v-row>
            <v-row no-gutters>
                <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                    <div v-if="precision_overflow" class="error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                    <div v-if="addLoad_overflow" class="error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                </div>
            </v-row>
            </v-container>
        </div>
    </LayoutBlock>
</template>
<script>
import { tare_item } from '../../../utils/itemBlockSchema';
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from '../../../components/utils/StatusIcon'
import {BaseLeg} from "../../../utils/baseLeg"
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon},
    mixins: [BaseLeg],

    watch: {
        measures: {
            deep: true,
            handler(){
                this.debouncedSave()
            }
        }

    },
    methods: {
        async buildMeasures() {
            this.measures = {
                hi_res: "off",
                tare_device: this.conf.tare_device,
                items: [],
                result: 'uncomplete'
            }
            let catvals = await this.buildWithCategory()
            if(catvals) {
                for (let i = 0 ; i < this.conf.min_readings ; i++){
                    let item = tare_item({
                        mass: catvals[i]
                })
                this.measures.items.push(item)
                this.changeTare(item)
                }
            } else {
               for (let i = 0 ; i < this.conf.min_readings ; i++){
                    let item = tare_item({})
                this.measures.items.push(item)
                this.changeTare(item)
                } 
            }
            // console.log("DEBUG items tare", this.measures)
        },
        // calculateAddLoadPlaceholder(mpe){
        //     if(mpe){
        //         return this.round(Big(mpe).times(0.25), this.high_precision)
        //     } else {
        //         return this.round(0, this.high_precision)
        //     }
        // },
        convertPlaceholders(items) {
            for (let item of items) {
                if(item.mass){
                    item.reading = this.round(0)
                    if (this.measures.hi_res == "off") {
                        item.addLoad = this.calculateAddLoadPlaceholder(item.reading)
                    }
                    this.changeTareReading(item)
                }
            }
        },
        changeTare(row){
            this.changeReading(row)
            if(row.mass){
                let temp = Big(this.calc_MPE(this.calcMinRange(row.mass), row.mass))
                row.mpe = temp.times(0.25).toString()
                this.calculateError(row)
            }
        },
        changeTareReading(row){
            this.changeReading(row)
            this.calculateError(row)
        },
        changeTareAddLoad(row){
            this.changeAddLoad(row)
            this.calculateError(row)
        },
        calculateError(row){
            if(row.reading != "" && row.reading != null && row.addLoad != "" && row.addLoad != null){
                if (row.p && row.mass && !this.addLoad_overflow ) {
                    row.error = this.round(Big(0).minus(row.p), this.high_precision)
                    this.calculateResult(row)
                } else {
                    row.result = "failed"
                }
            } else {
                row.result = "uncomplete"
            }
            
        }
    },
   
}
</script>

<style>

</style>
